// POSTS

export interface IPagedPosts {
  items: IPost[];
  totalCount: number;
  page: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IComment {
  id: string;
  accountId: string;
  username: string;
  accountPictureUrl: string;
  accountThumbUrl: string;
  message: string;
  created: Date;
  likes: number;
  userLikes: string[];
}

export enum ActionType {
  URL = "URL",
  DISPLAY = "DISPLAY",
  OBJECT3D = "3D_OBJECT",
  BILLBOARD = "BILLBOARD",
}

export enum Discipline {
  General = "General",
  Design = "Design",
  Safety = "Safety",
  Civil = "Civil",
  Structural = "Structural",
  Mechanical = "Mechanical",
  Hydraulic = "Hydraulic",
}

export interface Action {
  type: ActionType;
  value: string | number | boolean;
}

export interface Params {
  actions: Action[];
}

export interface IPost {
  id: string;
  accountId: string;
  altitude: number;
  body: string;
  canEdit: boolean;
  comments: IComment[];
  created: Date;
  creatorAvatarURL?: string;
  creatorThumbURL?: string;
  discipline: Discipline;
  heading: number;
  latitude: number;
  likes: number;
  longitude: number;
  params: string;
  pictureURL: string;
  provider: string;
  sharedWith?: string[];
  status: string;
  thumbURL: string;
  type: string;
  updated: Date;
  userLikes: string[];
  userName: string;
  what3words: string;
  shapeFileId?: string;
  poiFileId?: string;
  seaLevel?: number;
}

export interface IPostCreate {
  // id: string;
  // accountId: string;
  pictureBase64: string;
  body: string;
  discipline: Discipline;
  latitude: number;
  longitude: number;
  altitude: number;
  params: string;
  status: string;
  sharedWith?: string[];
  shapeFileId?: string;
  what3words: string;
  poiFileId?: string;
  seaLevel?: number;
}

// SEARCH DTOs

export interface ISearch {
  userName?: string;
  body?: string;
  discipline?: string;
  status?: string;
  startCreatedDate?: Date;
  endCreatedDate?: Date;
  latitude?: number;
  longitude?: number;
  distance?: number;
  page?: number;
  pageSize?: number;
}

// HOMPAGE SECTIONS

export interface IHomepageSections {
  features: React.MutableRefObject<null | HTMLElement>;
  useCases: React.MutableRefObject<null | HTMLElement>;
  advantages: React.MutableRefObject<null | HTMLElement>;
  contact: React.MutableRefObject<null | HTMLElement>;
  demo: React.MutableRefObject<null | HTMLElement>;
}
